import * as styles from "./css/Button.module.css";
const Button = props => {
    return (<button type={props.type ? props.type : "button"} form={props.form} onClick={() => (props.onClick ? props.onClick() : null)} class={`${styles.button}${props.focused ? ` ${styles.focused}` : ``}${props.class ? ` ${props.class}` : ``}`} tabIndex={props.tabIndex || 0} autofocus={props.autoFocus} disabled={props.disabled || props.submitting} aria-label={props.name} name={props.name}>
            {props.children}
        </button>);
};
export { Button };
